import { FullWidthSpace } from "melco-ui";
import { useLocation } from "react-router";
import { ReportingMelcoMachineStatisticsModelsView } from "melco-shared-logic";
import { MachineStatusView } from "../../components/view/MachineStatusView";

type ViewDetailsProps = {
  view?: any;
};

// Define the type for the state that will be passed through the navigate function
interface StateType {
  apiResponse: ReportingMelcoMachineStatisticsModelsView;
  access_token: string;
  password: string;
  user_id: string;
}

export const ViewDetails: React.FC<ViewDetailsProps> = () => {
  const location = useLocation() as { state: StateType | undefined };

  const {
    apiResponse: view,
    access_token,
    password,
    user_id,
  } = location.state || {}; // Destructure the state data

  return (
    <FullWidthSpace direction="vertical" size="large">
      <MachineStatusView
        view={view}
        password={password ?? ""}
        access_token={access_token ?? ""}
        user_id={user_id ?? ""}
      />
    </FullWidthSpace>
  );
};
